import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "../src/assets/css/common.css";
import './utils/rem'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
